import React from 'react';
import { Button, Modal } from '@blend-ed/blendx-ui';
import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import messages from './messages';

function ActionModalSupport({ intl, isOpen, handleClose, handleConfirm }) {
    return (
        <Modal show={isOpen} onClose={handleClose} >
            <Modal.Header
                title="Confirm Delete Ticket"
            />
            <Modal.Body>
                <p className="modal-body__text">{intl.formatMessage(messages.deleteConfirmation)}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ghost-gray" onClick={handleClose}>{intl.formatMessage(messages.cancelButton)}</Button>
                <Button variant="ghost-danger" onClick={handleConfirm}>{intl.formatMessage(messages.deleteButton)}</Button>
            </Modal.Footer>
        </Modal>
    );
}

ActionModalSupport.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ActionModalSupport);